class SiteLicense {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.logoUrl = data.logoUrl;
    this.startDate = data.startDate;
  }
}
export default SiteLicense
